import { useMemo } from 'react';
import { createCatch, saveCatch, deleteCatch, fetchCatchStats } from 'src/api';
import { fetchCatches as fetchCatchesV2 } from 'src/api/api2';

import { useSWR } from 'src/utils/swr';
import { useAction } from 'src/hooks/action';
import { useSystemStore } from 'src/stores';

export function useFetchCatches({ pageIndex, pageSize, sortBy, filter }) {
  const { token } = useSystemStore();
  const defaultValue = useMemo(() => ({ items: [], pageCount: 0, total: 0 }), []);

  return useSWR(['/catches', pageIndex, sortBy.id, sortBy.desc, filter],
    () => fetchCatchesV2({ pageIndex, pageSize, sortBy, filter }, token),
    { defaultValue }
  );
}

export function useFetchCatcheStats({ group_id, time_from, time_to }) {
  const { token } = useSystemStore();
  const defaultValue = useMemo(() => ([]), []);

  return useSWR(['/catchesstats', group_id, time_from, time_to],
    () => fetchCatchStats({ group_id, time_from, time_to }, token),
    { defaultValue }
  );
}

export function useCreateOrUpdateCatch(mutate) {
  const { token } = useSystemStore();
  return useAction(data => data.history_id ? saveCatch(data, token) : createCatch(data, token), mutate);
}

export function useDeleteCatch(mutate) {
  const { token } = useSystemStore();
  return useAction(data => deleteCatch(data, token), mutate);
}

